import PropTypes from 'prop-types';
import React from 'react';
import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';
import { COMPANY_PROPTYPES } from '../../../Includes/CompanyProps';

import './EmployerNotClaimedBox.scss';

export default class EmployerNotClaimedBox extends React.PureComponent {
    handleClaimPageClickMetrics = () => {
        const { company } = this.props;
        EmitMetric({
            misc_event_type: 'claim-page-clicked',
            misc_event_count: 1,
            company_id: company.companyId,
        });
    };

    render() {
        const { company } = this.props;

        const claimPageHref = `/employers-claim-company?id=${company.companyId}`;

        const descriptionText = `Would you like to hear from the HR department at ${company.companyName}? Tell us and we'll ask them.`;

        return (
            <div className="component-CompanyPages-Sections-EmployerNotClaimedBox">
                <div className="claim-box-title">
                    This employer has not claimed their page.
                </div>
                <div className="claim-box-description">{descriptionText}</div>
                <div className="claim-page-button">
                    <a
                        href={claimPageHref}
                        title="Claim this page"
                        onClick={this.handleClaimPageClickMetrics}
                    >
                        Claim this page
                    </a>
                </div>
            </div>
        );
    }
}

EmployerNotClaimedBox.propTypes = {
    company: PropTypes.shape(COMPANY_PROPTYPES).isRequired,
};
